import { generateUuidList, isMobileDevice } from '@frontend/libs/utils'
import ProductItemLoader from '@scripts/frontend/features/products/components/product-item/ProductItemLoader'

export function ProductSliderLoader() {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {generateUuidList(isMobileDevice ? 2 : 4).map((item) => (
        <ProductItemLoader key={item} />
      ))}
    </div>
  )
}

export default ProductSliderLoader
